/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const customerWalletTopUpDataSchema = z.object({
	id: z.string(),
	url: z.string(),
})

export type CustomerWalletTopUpDataSchema = z.infer<typeof customerWalletTopUpDataSchema>
